export default __webpack_public_path__ + "static/media/safety.c12ec537.svg";